import { Record } from "immutable";

import { AccessReviewPermissionModel, type TAccessReviewPermissionStatus } from "./AccessReviewPermissionModel";
import { AccessReviewSubordinateModel } from "./AccessReviewSubordinateModel";
import { IntegrationResourceRoleModel } from "./IntegrationResourceRoleModel";

const defaults = {
  accessReviewPermission: null as AccessReviewPermissionModel | null,
  accessReviewPermissionId: "",
  accessReviewSubordinate: null as AccessReviewSubordinateModel | null,
  accessReviewSubordinateId: "",
  createdAt: new Date(0),
  id: "",
  status: "" as TAccessReviewPermissionStatus,
  virtualRole: null as IntegrationResourceRoleModel | null,
  virtualRoleId: "",
};

export class AccessReviewSubordinatePermissionModel extends Record<typeof defaults>(defaults) {
  get integrationId() {
    return this.virtualRole
      ? this.virtualRole.integrationResource!.integrationId
      : this.accessReviewPermission!.integrationActorPermission!.integrationActor!.integrationId;
  }

  get resourceName() {
    return this.virtualRole ? this.virtualRole.integrationResource!.name : this.accessReviewPermission!.resourceName;
  }

  get roleName() {
    return this.virtualRole ? this.virtualRole.name : this.accessReviewPermission!.roleName;
  }

  static fromServerData(data: unknown): AccessReviewSubordinatePermissionModel {
    const {
      accessReviewPermission,
      accessReviewPermissionId,
      accessReviewSubordinate,
      accessReviewSubordinateId,
      createdAt,
      id,
      status,
      virtualRole,
      virtualRoleId,
    } = data as typeof defaults;
    return new AccessReviewSubordinatePermissionModel({
      accessReviewPermission: accessReviewPermission
        ? AccessReviewPermissionModel.fromServerData(accessReviewPermission)
        : null,
      accessReviewPermissionId,
      accessReviewSubordinate: accessReviewSubordinate
        ? AccessReviewSubordinateModel.fromServerData(accessReviewSubordinate)
        : null,
      accessReviewSubordinateId,
      createdAt: new Date(createdAt),
      id,
      status,
      virtualRole: virtualRole ? IntegrationResourceRoleModel.fromServerData(virtualRole) : null,
      virtualRoleId,
    });
  }
}
